import React from 'react';
import { Grid, SvgIcon } from '@material-ui/core';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import { ReactionsModel, ReactionsType } from './NewsfeedModels';
import { Colors, Text } from 'library';

const ReactionIconMap = {
    LIKE: { icon: <ThumbUpIcon fontSize="small" /> },
};

const Reactions = ({ reactions }: { reactions: ReactionsModel }) => {
    const getReaction = (reaction: ReactionsType) => (
        <Grid key={reaction} container direction="row" alignItems="center">
            <SvgIcon
                style={{
                    color: Colors.white,
                    backgroundColor: Colors.darkNavy,
                    width: 20,
                    height: 20,
                    padding: 4,
                    borderRadius: 10,
                }}
            >
                {ReactionIconMap[reaction].icon}
            </SvgIcon>
            <Text variant="deprecatedCaption" textStyle={{ marginLeft: 5, lineHeight: 0 }}>
                {reactions[reaction].count} like{reactions[reaction].count === 1 ? '' : 's'}
            </Text>
        </Grid>
    );

    return (
        <Grid>
            {(Object.keys(reactions) as ReactionsType[]).map((reaction) =>
                (reactions[reaction].count ?? 0) > 0 ? getReaction(reaction) : null,
            )}
        </Grid>
    );
};

export default Reactions;
